module.exports = __webpack_public_path__ + "static/005.thumb-ad44107c0922ec361e0c45f029975271.jpg";